import { createBrowserHistory } from '../../../gulp/node_modules/history';
let history = createBrowserHistory();

const newsList = {
	
	ui: {},

	listTotal: 0,
	
	filterSlug: '',
	
	masonryOptions: {
		itemSelector: '.js-newsListMasonry-item',
		gutter: '.js-newsListMasonry-gutter',
		columnWidth: '.js-newsListMasonry-sizer',
		horizontalOrder: true,
		percentPosition: true,
		initLayout: true,
		transitionDuration: 0
	},
	masonryIsActive: false,

	init: function() {
		this.bindUI();
		this.bindEvents();

		this.listTotal = $('.js-ajax-list-total').val();
		this.filterSlug = this.ui.$newsListFilter.attr('data-filter-slug');
	},

	bindUI: function() {
		this.ui.$newsList = $('.js-newsList');
		this.ui.$newsListCount = $('.js-newsList-count');
		this.ui.$newsListFilter = $('.js-newsListFilter');
		this.ui.$newsListFilterLoader = $('.js-newsListFilter-loader');
		this.ui.$newsListMasonry = $('.js-newsListMasonry');
		this.ui.$loadMoreButton = $('.js-newsList-loadMore');
		this.ui.$ajaxFilterInput = $('.js-ajax-filter-input');
	},

	bindEvents: function() {
		this.ui.$newsListFilter.on('change', this.filterList.bind(this));
		this.ui.$loadMoreButton.on('click', this.loadMoreNews.bind(this));
	},

	loadMoreNews: function(e) {
		let $button = $(e.currentTarget);
		let $currentList = $button.closest('.js-ajax-list');
		let $pageInput = $currentList.find('.js-ajax-page-input');
		let currentPage = $pageInput.val();
		let formDatas = $currentList
			.find('.js-form-loadMore')
			.filter(function (index, element) {
				return $(element).val() !== ''
			})
			.serialize();

		if(!$button.hasClass('is-loading')){
			$button.addClass('is-loading');
			$.ajax({
				url: template_vars.ajax_url,
				type: 'POST',
				data: formDatas,
				success: (result) => {
					let $result = $( result );

					currentPage++;
					$pageInput.val(currentPage);
					$button.removeClass('is-loading');

					this.ui.$newsList.append($result);

					if(this.ui.$newsList.find('.js-newsCard').length >= this.listTotal) {
						$button.hide();
					} else {
						$button.show();
					}
				},
				error: function () {
					$button.removeClass('is-loading').addClass('is-error');
				},
			})
		}
	},

	filterList: function(e) {
		let $select = $(e.currentTarget);
		let $currentList = $select.closest('.js-ajax-list');
		let $pageInput = $currentList.find('.js-ajax-page-input');
		let formDatas = $currentList
			.find('.js-form-filterList')
			.filter(function (index, element) {
				return $(element).val() !== ''
			})
			.serialize();

		if(!this.ui.$newsListFilterLoader.hasClass('is-loading')){
			this.ui.$newsListFilterLoader.addClass('is-loading');
			this.ui.$newsList.html('');

			// Add the filter to the url, so we can refresh and keep the filter
			history.push('?'+this.filterSlug+'='+this.ui.$newsListFilter.val());
			
			$.ajax({
				url: template_vars.ajax_url,
				type: 'POST',
				data: formDatas,
				success: (result) => {
					let $result = $( result );
					
					this.ui.$newsListFilterLoader.removeClass('is-loading');

					this.ui.$newsList.html($result);

					// We set the select value to the hidden input we use when we click on the load more button
					this.ui.$ajaxFilterInput.val($select.val());
					this.listTotal = $('.js-ajax-list-total').val();
					this.ui.$newsListCount.html('('+this.listTotal+')');
					$pageInput.val(2);

					if(this.ui.$newsList.find('.js-newsCard').length >= this.listTotal) {
						this.ui.$loadMoreButton.hide();
					} else {
						this.ui.$loadMoreButton.show();
					}
				},
				error: () => {
					this.ui.$newsListFilterLoader.removeClass('is-loading').addClass('is-error');
				},
			})
		}
	},
};

module.exports = newsList;